import React, { PureComponent } from 'react';
import {nl2br} from '../../utils/utils'

class AgreeContent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
           "defaultTxt" : "1. 목적 : 참여자 경품(기프티콘) 추첨 및 발송<br>2. 항목 : 포탈ID, 성명 및 연락처(ID연계)\n3. 보유기간 : 경품(기프티콘) 추첨 및 발송 후 6개월"
        }
        this.handleClickClose = this.handleClickClose.bind(this);
    }

    componentDidMount() {

    }

    handleClickClose() {
        this.props.close()
    }

    render() {
        const innerStyle = {
            zIndex:"103"
        }
        const innerBlue = {
            color : "blue"
        }
        return (
            <div className="layer_wrap layer_wrap_type2 advisor_layer_wrap agreement" style={innerStyle}>
            <div className="layer_inner">
            <div className="layer_cont">
                <h2 className="layer_h_tit" >개인정보 수집 및 이용 동의</h2>
				{ this.props.type === "feedback" && 
					<div className="agreeText" dangerouslySetInnerHTML={{__html:nl2br(this.props.data.feedback.piaFeedback)}}/>
				}
				{ this.props.type === "event" && 
					<div className="agreeText" dangerouslySetInnerHTML={{__html:nl2br(this.props.data.event.piaEvent)}}/>
				}
				{ this.props.type === "event_doi" && 
					<div className="agreeText" dangerouslySetInnerHTML={{__html:nl2br(this.props.data.event.doiEvent)}}/>
				}
                <div className="btn_area">
                    <button type="button" className="layer_btn" onClick={this.handleClickClose}>확인</button>
                </div>
            </div>
            </div>
            </div>
        );
    }
};

export default AgreeContent;




